import { z } from "zod";

import { useToastStore } from "./toast-store";

const axiosErrorSchema = z.object({
  response: z.object({
    data: z.object({
      status: z.number(),
      success: z.boolean(),
      error: z.object({
        code: z.string(),
        message: z.string(),
      }),
    }),
  }),
});

export const validateError = (data: unknown) => {
  const parsedError = axiosErrorSchema.safeParse(data);

  if (parsedError.success) {
    return parsedError.data;
  }

  return undefined;
};

const pushErrorToast = (error: unknown, fallbackMessage: string): void => {
  const pushToast = useToastStore.getState().pushToast;

  const message = validateError(error)?.response.data.error.message;

  void pushToast({
    type: "error",
    title: message ? "Validation Error" : "Error",
    // `||` and not `??`: the API can answer with an empty message, and an empty
    // string still has to fall back to something readable.
    message: message || fallbackMessage,
  });
};

export const errorToast = (error: unknown): void => {
  pushErrorToast(error, "Unknown error");
};

/**
 * Same parsing as `errorToast`, but replaces the generic "Unknown error" with a
 * message naming the action that failed. Takes the fallback first and returns
 * the handler so that `errorToast` stays single-argument: it is passed straight
 * to TanStack Query's `onError`, whose second argument is the mutation
 * variables, so adding a second parameter to it breaks every call site.
 */
export const errorToastWithFallback = (fallbackMessage: string) => {
  return (error: unknown): void => {
    pushErrorToast(error, fallbackMessage);
  };
};
